import { createSignal, onMount } from 'solid-js';

const [isHydrating, setIsHydrating] = createSignal(true);

export function useHydration() {
    return isHydrating;
}

export function HydrationProvider() {
    onMount(() => {
        // Flip the signal to false after hydration is complete
        setIsHydrating(false);
    });

    return null; // No visual component needed
}
